import { redirectSchema } from "@/router/dtos";
import type { RouteRecordRaw } from "vue-router";
import LoginPage from "./LoginPage.vue";
import VerifyLoginCodePage from "./VerifyLoginCodePage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    props: (route) => ({
      redirect: redirectSchema.parse(route.query),
    }),
  },
  {
    path: "/login/verify",
    name: "verifyLogin",
    component: VerifyLoginCodePage,
    props: (route) => ({
      redirect: redirectSchema.parse(route.query),
    }),
  },
];

export default routes;
